export enum SidePaneTabId {
  PREP = 'prep',
  NOTES = 'notes',
  GOALS = 'goals',
  PATIENT = 'patient',
  CHART_HISTORY = 'chart-history',
  JOURNAL = 'journal',
}
